import request from "@/utils/request.js"
// 获取影赛详情
export function getShadowGameDetailAPI(data){
  return request({
  	  method:'GET',
  	  url:'/api/shadow_game/'+data.id,
  	  params:data
  })
}
//影赛类型列表
export function shadow_game_type_api(data){
  return request({
  	  method:'GET',
  	  url:`/api/shadow_game_type`,
  	  params:data
  })
}
//赛道所属相册照片列表
export function shadow_game_album_list_api(data){
  return request({
  	  method:'GET',
  	  url:`/api/shadow_game_album_list`,
  	  params:data
  })
}
//相册照片查看
export function shadow_game_album_photo_api(data){
  return request({
  	  method:'GET',
  	  url:`/api/shadow_game_album_photo`,
  	  params:data
  })
}
//相册点赞
export function shadow_game_album_dz_api(data){
  return request({
  	  method:'POST',
  	  url:`/api/shadow_game_album_like`,
  	  data:data
  })
}
//相册投票/取消投票
export function shadow_game_album_vote_api(data){
  return request({
  	  method:'POST',
  	  url:`/api/shadow_game_album_vote`,
  	  data:data
  })
}